import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
interface XtdhRatePillProps {
  readonly rateLabel: string;
  readonly totalLabel: string;
  readonly className?: string | undefined;
}
export function XtdhRatePill(t0) {
  const $ = _c(10);
  const {
    rateLabel,
    totalLabel,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx("tw-flex tw-flex-wrap tw-items-center tw-gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== rateLabel) {
    t2 = <span className="tw-text-sm tw-font-medium tw-text-iron-500"><span className="tw-tabular-nums">{rateLabel}</span> / day</span>;
    $[2] = rateLabel;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== totalLabel) {
    t3 = <span className="tw-min-w-[120px] tw-text-sm tw-font-semibold tw-text-iron-100">Total <span className="tw-tabular-nums">{totalLabel}</span> xTDH</span>;
    $[4] = totalLabel;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}